export default __webpack_public_path__ + "static/media/dashboard.7e6ced82.svg";